import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { icon, number } from "../../../../config";
import { onBlur, onFocus, onOpen } from "../../../../utils/kendo";

/**
 * Reusable confirmation popup for node deletion.
 * Shows a tick (confirm) and cross (cancel) anchored to the delete icon.
 */
const NodeDeleteConfirmPopup = ({ anchor, deleteRef, blurTimeoutRef, onConfirm, onCancel, hideOnBlur }) => (
  <Popup
    show={true}
    anchor={anchor}
    onOpen={() => onOpen(deleteRef)}
    anchorAlign={{ horizontal: "left", vertical: "middle" }}
    popupAlign={{ horizontal: "right", vertical: "middle" }}
    className='delete-role-popup'>
    <div
      className='delete-role-popup-inner d-flex align-items-center justify-content-between gap-2'
      tabIndex={number.ZERO}
      ref={deleteRef}
      id='delete-node-popup'
      onFocus={() => onFocus(blurTimeoutRef)}
      onBlur={() => onBlur(blurTimeoutRef, hideOnBlur)}>
      <span className='cursor-pointer red d-flex align-items-center' onClick={onConfirm}>
        {icon.CHECKBOX}
      </span>
     
    </div>
  </Popup>
);

export default NodeDeleteConfirmPopup;
